import { useEffect, useMemo, useRef } from 'react';
import {
  Box,
  Button,
  ButtonGroup,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import useCmsUsers from 'hooks/useCmsUsers';
import { DATETIME_FORMAT_STRING } from 'constants';

import PaginationComponent from 'components/segments/Pagination';
import ErrorDialogue from 'components/segments/ErrorDialogue';
// import DeleteDialogue from 'components/segments/DeleteDialogue';
import { TableBox } from 'components/segments/StyledComponents';

const List = () => {
  const listOnLoad = useRef();
  const {
    cmsUsers,
    currentPage,
    pages,
    // count,
    isRequesting,
    lastUpdateError,
    getCmsUsersList
    // updateStatus,
    // deleteCmsUser
  } = useCmsUsers();

  const navigate = useNavigate();

  useEffect(() => {
    if (!listOnLoad.current) {
      listOnLoad.current = true;
      getCmsUsersList({ page: currentPage || 1 });
    }
  }, [currentPage, getCmsUsersList, cmsUsers]);

  const errorDisplay = useMemo(() => {
    if (!cmsUsers?.length) {
      const message =
        !listOnLoad.current || isRequesting ? 'Loading cms users...' : 'Sorry, no cms users found';
      return <Heading size='lg'>{message}</Heading>;
    }
    return null;
  }, [cmsUsers?.length, isRequesting]);

  const pageChangeHandler = page => {
    getCmsUsersList({ page, sort: { field: 'created', dir: -1 } });
  };

  // const handleDelete = cmsUser => {
  //   if (cmsUser) {
  //     deleteCmsUser({ cmsUser });
  //   }
  // };

  return (
    <Box>
      {errorDisplay}
      {!errorDisplay && (
        <TableBox my='12px' border='1px solid #000'>
          <Table size='sm'>
            <Thead>
              <Tr>
                <Th>Name</Th>
                <Th>Email</Th>
                <Th>Phone</Th>
                <Th>Last Login</Th>
                <Th>Enabled</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {cmsUsers.map((l, idx) => {
                return (
                  <Tr key={idx}>
                    <Td>
                      {l.firstName} {l.lastName}
                    </Td>
                    <Td>
                      <a href={`mailto${l.email}`}>{l.email}</a>
                    </Td>
                    <Td>{l.phone}</Td>
                    <Td>
                      {l.lastLogin
                        ? dayjs(l.lastLogin).format(DATETIME_FORMAT_STRING)
                        : 'no login record'}
                    </Td>
                    <Td>{l.enabled ? 'yes' : 'no'}</Td>
                    <Td>
                      <ButtonGroup spacing='3' size='xs'>
                        <Button onClick={() => navigate(`/cms-users/edit/${l._id}`)}>Edit</Button>
                        {/* <DeleteDialogue
                          label='Delete'
                          deleteConfirmLabel='Delete CmsUsers'
                          handleDelete={() => handleDelete({ cmsUser: l._id })}
                        /> */}
                      </ButtonGroup>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableBox>
      )}
      <ErrorDialogue error={lastUpdateError} />
      {pages > 1 && (
        <PaginationComponent
          numPages={pages}
          page={currentPage}
          pageChangeHandler={pageChangeHandler}
        />
      )}
    </Box>
  );
};

export default List;
